module.exports = __webpack_public_path__ + "static/media/memories_10.51cccbb1.jpg";